import { FIELD_TYPE } from '@/constants'

//import { getFirstName, getLabelName } from '../helper'

export default {
  apiKey: 'authorization.refDetails',
 // elemId: 'refDetailsScroll',
  type: FIELD_TYPE.COLLECTION,
  collapsible: true,
  showLine: true,
  description(application) {
    return getLabelName(
      'Provide names and phone numbers of at least two people that know about your situation and can answer any verification questions we may have about your case. References may NOT be currently living with you. One may be a family member, and the other may be a friend, community member, or caseworker.'
    )
  },
  heading(contactItem, index) {
    return 'Reference ' + index
  },
  headingAdd: 'Add another reference',
  headingAddOutline: true,
  newItem: {
    refRecordNo: null,
    refName: '',
    refPhone: '',
    refRelationship: '',
  },
  fields(refItem, refIndex) {
    var apiKeyPrefix = `${this.apiKey}[${refIndex}]`

    return [
      {
        apiKey: apiKeyPrefix + '.refName',
        label: `Reference Name`,
        placeHolder: "Enter Reference Name",
        description: 'Reference Full Name',
        required() {
          return (
            (refItem.refPhone ||
              refItem.refRelationship) &&
            !refItem.refName
          )
        },
        validation(value) {
          if (!/^[a-zA-Z ()'-]+$/.test(value)) {
            return `Can only contain letters, spaces, and - ( ) '`
          }
        },
        maxLength: 132
      },      
      {
        apiKey: apiKeyPrefix + '.refPhone',
        label: 'Phone Number',
        placeHolder: '(123) 456-7890',
        description: "Format: (123) 456-7890",
        type: FIELD_TYPE.PHONE,
        maxLength: 14,
        validation(value) {     
          if (!/^\d{10}$/.test(value.replace(/[^a-zA-Z0-9]+/g,''))) {
            return 'Please enter minimum 10 digits.'
          }
        }
      },
      {
        apiKey: apiKeyPrefix + '.refRelationship',
        label: 'Relationship to Client',        
        description: "Relationship to Client"        
      }
    ]
  }
}
